var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.OT !== null)?_c('v-card',{staticClass:"d-flex justify-end align-end subtotal-items",attrs:{"elevation":"1"}},[_c('p',{staticClass:"budgetTitle"},[_vm._v("Total del presupuestos aprobados:"),_c('span',[_vm._v(_vm._s(_vm._f("currency")(_vm.OT.total_price)))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }